import { http } from '@/core/api/';

const baseURL = 'api/atservicesrequest';

export const getATSolicitorPositiions = async () => {
  return await http.get(`${baseURL}/solicitorpositions`);
};

export const getATDocumentTypes = async () => {
  return await http.get('/api/documents/documenttypes', {
    params: { codetype: 'Solicitud_Servicio' },
  });
};

export const getReferralTypes = async () => {
  return await http.get(`${baseURL}/referraltypes`);
};

export const getATEvaluations = async (studentSieId) => {
  return await http.get(
    `api/studentevaluation/evaluationsforatservicerequest/${studentSieId}`
  );
};

export const downloadATServiceRequest = async (peiAtServiceId) => {
  return await http.get(`api/report/downloadrequestreport/${peiAtServiceId}`);
};

export const uploadSignedReferral = async (peiATServiceId, file) => {
  return await http.post(`${baseURL}/uploadsigned/${peiATServiceId}`, file);
};

export const createATServiceRequest = async (data) => {
  return await http.post(`${baseURL}/create`, data);
};

export const getPeiAtSeviceById = async (peiAtServiceId) => {
  return await http.get(`${baseURL}/${peiAtServiceId}`);
};

export const getPeiEquipments = async (studentSieId) => {
  return await http.get(`api/pei/equipments/${studentSieId}`);
};
